<template>
  <div class="animated fadeIn h-100 m-4">
    <CRow>
      <CCol sm="12">
        <CCard>
            <CCardHeader><span style="vertical-align: middle; line-height: 35 px"><CIcon name="cil-border-clear"/> Week distribution</span><span class="float-right"><date-picker ref="dateUntil" v-model="dateUntil" :config="options" style="width: initial;"></date-picker></span><span class="float-right align-bottom"><CSwitch class="mx-1 pt-2" color="info" @change.native="loadWeekBucket()" variant="opposite" shape="pill" size="sm" v-bind:checked.sync="categoryView"/> <span class="align-bottom mr-4">Category view</span></span></CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12">
                <bar :chart-data="hourcollection" :options="weekCountOptions" :height="100"></bar>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <vue-slider v-model="currentHour" v-bind="sliderOptions" :interval="1" :marks="hourMarks" :tooltip-formatter="hourFormater" class="p-4"/>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="6">
        <CCard>
          <CCardHeader><CIcon name="cil-border-clear"/> Last position of assets</CCardHeader>
          <CCardBody>
            <horizontal-bar :chart-data="datacollection" :options="zoneCountOptions" ></horizontal-bar>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Vue from 'vue'
import VueSlider from 'vue-slider-component'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'vue-slider-component/theme/antd.css'
import HorizontalBar from './charts/HorizontalBar.js'
import Bar from './charts/Bar.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { telemetry } from '@/api'

export default {
  name: 'Dashboard',
  components: {
    Bar,
    HorizontalBar,
    VueSlider,
    datePicker,
    ChartDataLabels
  },
  data () {
    return {
      datacollection: {},
      hourcollection: {},
      weekdata: {},
      categoryView: false,
      dateUntil: this.endOfDay(new Date()),
      currentHour: (new Date()).getHours(),
      options: {
        useCurrent: false,
        calendarWeeks: true,
        locale: 'sk'
      },
      sliderOptions: {
        min: 0,
        max: 23,
        interval: 1,
      },
      hourFormater: v => ((v<10?'0':'')+v+':00'),
      hourMarks: v => (!(v%3) || v==23 ? {label: (v<10?'0':'')+v+':00'} : false),
      zoneCountOptions: {
        responsive: true,
        scales: {
          xAxes: [{
            ticks: {
              suggestedMin: 1,
              suggestedMax: 100,
              stepSize: 1,
              callback: function(dataLabel, index) {
                // Hide the label of every 2nd dataset. return null to hide the grid line too
                return index % 2 === 0 ? dataLabel : '';
              }
            }
          }]
        },
        plugins: {
          // Change options for ALL labels of THIS CHART
          datalabels: {
            color: '#FFFFFF'
          }
        }
      },
      weekCountOptions: {
        responsive: true,
        scales: {
            xAxes: [{
                stacked: true,
            }],
            yAxes: [{
                stacked: true
            }]
        },
        plugins: {
          // Change options for ALL labels of THIS CHART
          datalabels: {
            color: '#FFFFFF'
          }
        }
      }
    }
  },
  watch: {
    currentHour: function(val) {
      this.fillWeek(val)
    },
    dateUntil: function(val) {
      this.loadWeekBucket()
    }
  },
  mounted () {
    telemetry.zoneCount().then(response => {
      if(response.data !== undefined) {
        this.fillData(response.data)
      }
    }).catch((error) => {
      this.$toasted.error(error)
    })
    this.loadWeekBucket()
  },
  methods: {
    loadWeekBucket() {
      telemetry.zoneCountBucket(this.categoryView, {untilDate: Date.parse(this.dateUntil)}).then(response => {
        if(response.data !== undefined) {
          this.weekdata = response.data
          this.fillWeek(this.currentHour)
        }
      }).catch((error) => {
        this.$toasted.error(error)
      })
    },
    fillWeek(hour) {
      if(this.weekdata.bucket != null && this.weekdata.bucket[hour] !== undefined) {
        this.hourcollection = JSON.parse(JSON.stringify(this.weekdata.bucket[hour]))
        //this.hourcollection = this.weekdata.bucket[hour]
        //console.log(this.weekdata.bucket[hour])
      } else {
        this.hourcollection = { labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'], datasets: [] }
      }

    },
    endOfDay(date) {
      date.setHours(23,59,59,999)
      return date
    },
    fillData (data) {
      this.datacollection = {
        labels: [],
        datasets: [{label: "Assets in zone", backgroundColor: '#39f', data: []}]
      }
      var deviceCount = 0
      for(var idx=0; idx < data.length; idx++) {
        if(data[idx].area == false) {
          this.datacollection.labels.push(data[idx].name)
          this.datacollection.datasets[0].data.push(data[idx].count)
          deviceCount += parseInt(data[idx].count)
        }
      }
      this.zoneCountOptions.scales.xAxes[0].ticks.suggestedMax = deviceCount
    }
  }
}
</script>
